import React, { useMemo, useState } from 'react';
import ProductCardProps from './types/ProductCardProps';
import ProductCardWithDetailsMobile from './ProductCardWithDetailsMobile';
import ProductCardWithDetails from './ProductCardWithDetails';

const ProductCardWithDetailsContainer = ({
  product,
  lazyLoadImage,
  className,
  showInfo = true,
  showRoomshot = false,
}: ProductCardProps) => {
  const [quantity, setQuantity] = useState<number | undefined>(0);
  const [boxesAmount, setBoxesAmount] = useState<number>(0);
  const [rollsAmount, setRollsAmount] = useState<number>(0);
  const [totalAmount, setTotalAmount] = useState<number>(0);
  const [packageSize, setPackageSize] = useState<number>(0);
  useMemo(
    () =>
      setPackageSize(
        product.itemPackageSize ? product.itemPackageSize : 1
      ),
    []
  );
  return (
    <>
      <ProductCardWithDetails
        product={product}
        lazyLoadImage={lazyLoadImage}
        className={className}
        showInfo={showInfo}
        showRoomshot={showRoomshot}
        quantity={quantity}
        boxesAmount={boxesAmount}
        rollsAmount={rollsAmount}
        totalAmount={totalAmount}
        packageSize={packageSize}
        setQuantity={setQuantity}
        setBoxesAmount={setBoxesAmount}
        setRollsAmount={setRollsAmount}
        setTotalAmount={setTotalAmount}
        setPackageSize={setPackageSize}
      />
      <ProductCardWithDetailsMobile
        product={product}
        lazyLoadImage={lazyLoadImage}
        className={className}
        showInfo={showInfo}
        showRoomshot={showRoomshot}
        quantity={quantity}
        boxesAmount={boxesAmount}
        rollsAmount={rollsAmount}
        totalAmount={totalAmount}
        packageSize={packageSize}
        setQuantity={setQuantity}
        setBoxesAmount={setBoxesAmount}
        setRollsAmount={setRollsAmount}
        setTotalAmount={setTotalAmount}
        setPackageSize={setPackageSize}
      />
    </>
  );
};

export default ProductCardWithDetailsContainer;
